export default "__VITE_ASSET__44f5a314__"